import request from "../Config/axios";

// -----------------------------------------------------------
export const GetAll_Paging_ObjectInstance_Api = async (params) => {
    const { data } = await request.post(
        `/ObjectInstance/GetAll_Paging`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const GetAll_ObjectInstance_Api = async () => {
    //console.log("hrr1")
    const { data } = await request.get(
        `/ObjectInstance/GetAll/`
    );
    //console.log("hrr2")

    return data;
};
// -----------------------------------------------------------
export const GetAllInCategory_ObjectInstance_Api = async (categoryId) => {
    const { data } = await request.get(
        `/ObjectInstance/GetAll_InCategory/?categoryId=${categoryId}`
    );
    return data;
};
// -----------------------------------------------------------
export const Delete_ObjectInstance_Api = async (id) => {
    const { data } = await request.delete(
        `/ObjectInstance/Delete/?id=` + id,
    );
    return data;
};
// -----------------------------------------------------------
export const Add_ObjectInstance_Api = async (params) => {
    const { data } = await request.post(
        `/ObjectInstance/Add`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const GetById_ObjectInstance_Api = async (id) => {
    const { data } = await request.get(
        `/ObjectInstance/GetById/?id=${id}`
    );
    return data;
};
// -----------------------------------------------------------
export const Update_ObjectInstance_Api = async (params) => {
    const { data } = await request.post(
        `/ObjectInstance/Update`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const AddToCategory_ObjectInstance_Api = async (params) => {
    const { data } = await request.post(
        `/ObjectInstance/AddToCategory`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const RemoveFromCategory_ObjectInstance_Api = async (params) => {
    const { data } = await request.post(
        `/ObjectInstance/RemoveFromCategory`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const GetAllowedForReserve_ObjectInstance_Api = async (reserveId) => {
    const { data } = await request.get(
        `/ObjectInstance/GetAllowedForReserve/?reserveId=${reserveId}`
    );
    return data;
};
// -----------------------------------------------------------
export const GetAll_InSubPeriod_ObjectInstance_Api = async (subPeriodId) => {
    const { data } = await request.get(
        `/ObjectInstance/GetAll_InSubPeriod/?subPeriodId=${subPeriodId}`
    );
    return data;
};